// A query string with list values as repeated keys (carrier=a&carrier=b),
// which is how FastAPI reads a list param; axios's default writes
// carrier[]=a. Unset (undefined/null) values are left out.
export const repeatKeys = (params) => {
    const search = new URLSearchParams()
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value === undefined || value === null) { return }
        [].concat(value).forEach(v => search.append(key, v))
    })
    return search.toString()
}

// A list-valued query param as read back from the URL: one value comes back
// as a string, several as an array, none as undefined. Always an array, so a
// `<select multiple>` v-model never receives a string (FLOW-FRONTEND-9J-4HB:
// Vue's select directive calls .some() on it).
export const listParam = (value) => {
    if (value === undefined || value === null || value === '') { return [] }
    return [].concat(value)
}
